import React from "react";
import { translate } from "react-i18next";
import compose from "ramda/src/compose";
import { bool, func } from "prop-types";
import { Modal, Button } from "shared/components";
import IconRepair from "../../../../assets/svg/icone-reparo-modal.svg";
import styles from "./styles.css";

const ModalProblemSolved = ({
  t,
  isCurrentStep,
  onPreviousStep,
  onNextStep,
}) => {
  return (
    <Modal
      isOpen={isCurrentStep}
      onClose={onPreviousStep}
      title={t("MSG_0194")}
      icon={IconRepair}
    >
      <div className={styles.root}>
        <p>{t("MSG_0198")}</p>
        <div className={styles.action}>
          <Button onClick={onNextStep} relevance="normal">
            {t("MSG_0199")}
          </Button>
          <Button onClick={onNextStep} relevance="normal" callToAction>
            {t("MSG_0200")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

ModalProblemSolved.protoTypes = {
  isOpen: bool,
  onClose: func.isRequired,
};

ModalProblemSolved.defaultProps = {
  isOpen: false,
};

const enhance = compose(translate());

export default enhance(ModalProblemSolved);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalProblemSolved/index.js